export class SubstationOperationPara {
    constructor({
        id= ``,
        prdDate= ``,
        recTime= ``,
        locName= ``,
        locId= ``,
        furnaceNumber= ``,
        eGear1= ``,
        eGear2= ``,
        eGear3= ``,
        secondaryVoltage1= ``,
        secondaryVoltage2= ``,
        secondaryVoltage3= ``,
        primaryCurrentA= ``,
        primaryCurrentB= ``,
        primaryCurrentC= ``,
        secondaryCurrentA= ``,
        secondaryCurrentB= ``,
        secondaryCurrentC= ``,
        setedPower= ``,
        activePower= ``,
        reactivePower= ``,
        inspectingPower= ``,
        powerFactor= ``,
        totalCost= ``,
        eCurrent1= ``,
        eCurrent2= ``,
        eCurrent3= ``,
        eWeight1= ``,
        eWeight2= ``,
        eWeight3= ``,
        resistance1= ``,
        resistance2= ``,
        resistance3= ``,
    }={}){
        this.id = id;
        this.prdDate = prdDate;
        this.recTime = recTime;
        this.locName = locName;
        this.locId = locId;
        this.eGear1 = eGear1;
        this.eGear2 = eGear2;
        this.eGear3 = eGear3;
        this.furnaceNumber = furnaceNumber;
        this.secondaryVoltage1 = secondaryVoltage1;
        this.secondaryVoltage2 = secondaryVoltage2;
        this.secondaryVoltage3 = secondaryVoltage3;
        this.primaryCurrentA = primaryCurrentA;
        this.primaryCurrentB = primaryCurrentB;
        this.primaryCurrentC = primaryCurrentC;
        this.secondaryCurrentA = secondaryCurrentA;
        this.secondaryCurrentB = secondaryCurrentB;
        this.secondaryCurrentC = secondaryCurrentC;
        this.setedPower = setedPower;
        this.activePower = activePower;
        this.reactivePower = reactivePower;
        this.inspectingPower = inspectingPower;
        this.powerFactor = powerFactor;
        this.totalCost = totalCost;
        this.eCurrent1 = eCurrent1;
        this.eCurrent2 = eCurrent2;
        this.eCurrent3 = eCurrent3;
        this.eWeight1 = eWeight1;
        this.eWeight2 = eWeight2;
        this.eWeight3 = eWeight3;
        this.resistance1 = resistance1;
        this.resistance2 = resistance2;
        this.resistance3 = resistance3;
    }
}

export function gridFields() {
    return Object.freeze([
        {
            key: 'prdDate',
            label: 'lbl.basic.date',
            sortable: true,
            form: {
              type: 'datepicker'
            }
        },
        {
            key: 'recTime',
            label: 'lbl.basic.datetime',
            sortable: true,
            form: {
              type: 'timepicker'
            }
        },
        {
          key: 'locName',
          label: 'lbl.fm.locationName',
          filterable: true,
          default: 'default',
          form: {
            type: 'dimSearch',
            url: process.env.VUE_APP_MASTER_API_URL + 'master-service/master/location/findAll',
            config: {
              validate: "", // 参数检查，可以是正则表达式等
              bindId: 'smeltingLocation', // 绑定的 id, (id 相同的对象会被绑定)
              bindProp: "locName", // 显示的属性的名称
              submitProp: "locName" // 提交的属性
            }
          }
        },
        {
          key: 'locId',
          label: 'lbl.formulaPlan.locationCode',
          // uneditable: true,
          notInTable: true,
          // unlistable: true,
          // sortable: true,
          form: {
            type: 'dimSearch',
            url: process.env.VUE_APP_MASTER_API_URL + 'master-service/master/location/findAll',
            config: {
              validate: "", // 参数检查，可以是正则表达式等
              bindId: 'smeltingLocation', // 绑定的 id, (id 相同的对象会被绑定)
              bindProp: "id", // 显示的属性的名称
              submitProp: "id" // 提交的属性
            }
          }
        },
        {
          key: 'furnaceNumber',
          label: 'lbl.basic.furnaceName',
          filterable: true,
          sortable: true,
          default: 'default',
          form: {
          type: 'select',
          options: [
            {value:"default", text:"lbl.basic.select.one"},
            {value:"1", text:"opt.furnaceNumber1"},
            {value:"2", text:"opt.furnaceNumber2"},
            {value:"3", text:"opt.furnaceNumber3"},
            {value:"4", text:"opt.furnaceNumber4"},
            {value:"5", text:"opt.furnaceNumber5"},
            {value:"6", text:"opt.furnaceNumber6"}
            ]
          }
        },
        {
            key: 'eGear1',
            label: 'lbl.sop.eGear1',
            sortable: true,
            form: {
              type: 'input'
            }
        },
        {
            key: 'eGear2',
            label: 'lbl.sop.eGear2',
            sortable: true,
            form: {
              type: 'input'
            }
        },
        {
            key: 'eGear3',
            label: 'lbl.sop.eGear3',
            sortable: true,
            form: {
              type: 'input'
            }
        },
        {
            key: 'secondaryVoltage1',
            label: 'lbl.sop.secondaryVoltage1',
            sortable: true,
            form: {
              type: 'input'
            }
        },
        {
            key: 'secondaryVoltage2',
            label: 'lbl.sop.secondaryVoltage2',
            sortable: true,
            form: {
              type: 'input'
            }
        },
        {
            key: 'secondaryVoltage3',
            label: 'lbl.sop.secondaryVoltage3',
            sortable: true,
            form: {
              type: 'input'
            }
        },
        {
            key: 'primaryCurrentA',
            label: 'lbl.sop.primaryCurrentA',
            sortable: true,
            form: {
              type: 'input'
            }
        },
        {
            key: 'primaryCurrentB',
            label: 'lbl.sop.primaryCurrentB',
            sortable: true,
            form: {
              type: 'input'
            }
        },
        {
            key: 'primaryCurrentC',
            label: 'lbl.sop.primaryCurrentC',
            sortable: true,
            form: {
              type: 'input'
            }
        },
        {
            key: 'secondaryCurrentA',
            label: 'lbl.sop.secondaryCurrentA',
            sortable: true,
            form: {
              type: 'input'
            }
        },
        {
            key: 'secondaryCurrentB',
            label: 'lbl.sop.secondaryCurrentB',
            sortable: true,
            form: {
              type: 'input'
            }
        },
        {
            key: 'secondaryCurrentC',
            label: 'lbl.sop.secondaryCurrentC',
            sortable: true,
            form: {
              type: 'input'
            }
        },
        {
            key: 'setedPower',
            label: 'lbl.sop.setedPower',
            sortable: true,
            form: {
              type: 'input'
            }
        },
        {
            key: 'activePower',
            label: 'lbl.sop.activePower',
            sortable: true,
            form: {
              type: 'input'
            }
        },
        {
            key: 'reactivePower',
            label: 'lbl.sop.reactivePower',
            sortable: true,
            form: {
              type: 'input'
            }
        },
        {
            key: 'inspectingPower',
            label: 'lbl.sop.inspectingPower',
            sortable: true,
            form: {
              type: 'input'
            }
        },
        {
            key: 'powerFactor',
            label: 'lbl.sop.powerFactor',
            sortable: true,
            form: {
              type: 'input'
            }
        },
        {
            key: 'totalCost',
            label: 'lbl.sop.totalCost',
            sortable: true,
            form: {
              type: 'input'
            }
        },
        {
            key: 'eCurrent1',
            label: 'lbl.sop.eCurrent1',
            sortable: true,
            form: {
              type: 'input'
            }
        },
        {
            key: 'eCurrent2',
            label: 'lbl.sop.eCurrent2',
            sortable: true,
            form: {
              type: 'input'
            }
        },
        {
            key: 'eCurrent3',
            label: 'lbl.sop.eCurrent3',
            sortable: true,
            form: {
              type: 'input'
            }
        },
        {
            key: 'eWeight1',
            label: 'lbl.sop.eWeight1',
            sortable: true,
            form: {
              type: 'input'
            }
        },
        {
            key: 'eWeight2',
            label: 'lbl.sop.eWeight2',
            sortable: true,
            form: {
              type: 'input'
            }
        },
        {
            key: 'eWeight3',
            label: 'lbl.sop.eWeight3',
            sortable: true,
            form: {
              type: 'input'
            }
        },
        {
            key: 'resistance1',
            label: 'lbl.sop.resistance1',
            sortable: true,
            form: {
              type: 'input'
            }
        },
        {
            key: 'resistance2',
            label: 'lbl.sop.resistance2',
            sortable: true,
            form: {
              type: 'input'
            }
        },
        {
            key: 'resistance3',
            label: 'lbl.sop.resistance3',
            sortable: true,
            form: {
              type: 'input'
            }
        }
    ]);
}

export const fields = Object.freeze(Object.keys(new SubstationOperationPara()).map(i => 'entity.' + i));

export const filterFields = [
    'filter.startTimeFilter',
    'filter.endTimeFilter',
    'filter.furnaceNumberFilter',
    'filter.locNameFilter',
];

export const filter = {
    'startTimeFilter': "",
    'endTimeFilter': "",
    'furnaceNumberFilter': "default",
    'locNameFilter': "default",
};